import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export var SEND_EVENTS = 'SEND_EVENTS';
export var SET_TC_VARIABLES = 'SET_TC_VARIABLES';
export var RESET_TC_VARIABLES = 'RESET_TC_VARIABLES';